module.exports = __webpack_public_path__ + "static/media/code.c9406dab.jpg";